import DataLoader from "dataloader"
import { useSuspenseQuery } from "@tanstack/react-query"
import { getSimpleWorkAreasByIds, SimpleWorkArea } from "@/orval/gen"

const loader = new DataLoader<number, SimpleWorkArea | null>(
  async (keys) => {
    const results = await getSimpleWorkAreasByIds({
      workAreaIds: [...keys],
    })
    return keys.map((key) => results.find((x) => x.workAreaId === key) || null)
  },
  { batchScheduleFn: (callback) => setTimeout(callback, 100) }
)

export function useBatchedSimpleWorkArea(workAreaId: number) {
  return useSuspenseQuery({
    queryKey: ["SimpleWorkArea", workAreaId],
    queryFn: () => loader.load(workAreaId),
  })
}
